// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2GicS","signatureBlock":"Footer_signatureBlock__1Dz3B","signature":"Footer_signature__3WeYg"};